module.exports = __webpack_public_path__ + "img/ico-confirmed.a41f69c1.svg";